export default {
    adjustments: {
        title: "Justeringer",
        reset: "Nullstill",
        light: {
            title: "Lys",
            brightness: "Lysstyrke",
            contrast: "Kontrast",
            shadows: "Skygger",
        },
        color: {
            title: "Farge",
            saturation: "Metning",
            temperature: "Temperatur",
            blacks: "Svarte",
            whites: "Hvite",
        },
        detail: {
            title: "Detalj",
            clarity: "Klarhet",
            sharpness: "Skarphet",
            blur: "Sløre",
        },
    },
};
